import './owl.carousel'

const owlCarouselOptions = {
    // animateOut:     'fadeOut',
    items:           1,
    margin:          0,
    autoWidth:       0,
    autoHeight:      0,
    autoplay:        0,
    autoplayTimeout: 5000,
    center:          0,
    loop:            0,
    nav:             0,
    navContainer:    0,
    smartSpeed:      1000,
    dots:            0
}

jQuery('.carousel-container').each(function(){
    const $container = jQuery(this)
    const $carousel = $container.find('.carousel')

    const owlCarouselCustomOptions = {
        items:           $container.data('items') ? +$container.data('items') : owlCarouselOptions.items,
        margin:          $container.data('margin') ? +$container.data('margin') : owlCarouselOptions.margin,
        autoWidth:       $container.data('auto-width') ? +$container.data('auto-width') : owlCarouselOptions.autoWidth,
        autoHeight:      $container.data('auto-height') ? +$container.data('auto-height') : owlCarouselOptions.autoHeight,
        autoplay:        $container.data('autoplay') ? $container.data('autoplay') : owlCarouselOptions.autoplay,
        autoplayTimeout: $container.data('timeout') ? +$container.data('timeout') : owlCarouselOptions.autoplayTimeout,
        center:          $container.data('center') ? +$container.data('center') : owlCarouselOptions.center,
        loop:            $container.data('loop') ? $container.data('loop') : owlCarouselOptions.loop,
        nav:             $container.data('nav') ? $container.data('nav') : owlCarouselOptions.nav,
        navContainer:    $container.data('nav-container') ? $container.data('nav-container') : owlCarouselOptions.navContainer,
        smartSpeed:      $container.data('smart-speed') ? +$container.data('smart-speed') : owlCarouselOptions.smartSpeed,
        navText:         $container.data('nav-prev') && $container.data('nav-next') ? [$container.data('nav-prev'), $container.data('nav-next')] : ['<i>⟵</i>', '<i>⟶</i>'],
        dots:            $container.data('dots') ? $container.data('dots') : owlCarouselOptions.dots,
        slideBy:         $container.data('slide-by') ? $container.data('slide-by') : owlCarouselOptions.slideBy,
        responsive:      $container.data('responsive') ? $container.data('responsive') : 0,
    }

    $carousel.owlCarousel({
        ...owlCarouselOptions,
        ...owlCarouselCustomOptions
    })
})